import { type DropdownProps, Dropdown as UIDropdown } from '@carboncopyco/ui';
import { useTabStateCallback } from '../../hooks/useTabStateCallback';

const Dropdown = ({ children, ...rest }: DropdownProps) => {
  const { isActiveTab } = useTabStateCallback();

  if (!isActiveTab) return null;
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <UIDropdown {...rest}>{children}</UIDropdown>;
};

export default Dropdown;
